import React from "react";
import styled from "styled-components";

interface ButtonProps {
  width: number;
  height: number;
  color: string;
}

const ActionButton = (props: any) => {
  const { className, width, height, label, color, onClick, children } = props;
  return (
    <Button
      className={className}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
    >
      {label}
      {children}
    </Button>
  );
};

const Button = styled.button<ButtonProps>`
  width: ${(p) => `${p.width}px`};
  height: ${(p) => `${p.height}px`};
  background: ${(p) => p.color};
  border-radius: ${(p) => `${p.height / 2}px`};
  font-family: HelveticaNeue-Medium;
  font-size: 22px;
  color: #ffffff;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  border-color: transparent;
  transition: 0.3s ease-in;
  margin: 1.5rem 0;

  &:hover {
    opacity: 0.8;
  }
`;

export default ActionButton;
